<div class="user-groups-summary">
    <div *ngIf="selectedCount !== 1" class="arm-summary">{{selectedCount}} Items selected</div>
    <div *ngIf="selectedCount === 1" class="arm-summary">
        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Name:</span>
            <span [title]="userDetails.name" class="arm-summary-value" fxFlex>{{userDetails.name}}</span>
        </div>
        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Origin:</span>
            <span [title]="userDetails.origin" class="arm-summary-value" fxFlex>{{userDetails.origin}}</span>
        </div>

        <div class="arm-summary-item" fxLayout="row">
            <span class="arm-summary-name" fxFlex="45">Groups:</span>
            <span [title]="userDetails.groups" class="arm-summary-value" fxFlex>{{userDetails.groups}}</span>
        </div>

        <p>Dictionary Attributes:</p>
        <div class="user-details-list-item">
            <div *ngFor="let attr of userDetails.dicAttributes" class="arm-summary-item" fxLayout="row">
                <span class="arm-summary-name" fxFlex="45">{{attr.name}}</span>
                <span [title]="attr.value" class="arm-summary-value" fxFlex>{{attr.value}}</span>
            </div>
        </div>
    </div>
</div>
